import React from 'react'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardContent from '@material-ui/core/CardContent'
import Hidden from '@material-ui/core/Hidden'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Details from './details'
import Division from './division'
import ProgramName from './program-name'
import { Link } from 'react-router-dom'
import Schedule from './schedule'
import Statuses from './statuses'

const useStyles = makeStyles(theme => ({
  card: {
    border: `1px solid ${theme.palette.card.border}`,
    borderRadius: 12,
    boxShadow: 'none',

    '&:hover': {
      borderColor: theme.palette.card.borderHover,
    },

    '& + &': {
      marginTop: theme.spacing(3),
    },
  },
}))

export default function EventCard({ hit }) {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardActionArea
        component={Link}
        to={`/junior-league-events/${hit.objectID}`}
      >
        <CardContent>
          <Box p={1.5}>
            <Box
              alignItems="start"
              display="flex"
              flexWrap="wrap"
              justifyContent="space-between"
            >
              <div>
                <Schedule hit={hit} />
                <ProgramName hit={hit} />
                <Division hit={hit} />
              </div>

              <Hidden smDown implementation="css">
                <Statuses hit={hit} />
              </Hidden>
              <Details hit={hit} />
              <Hidden mdUp implementation="css">
                <Statuses hit={hit} />
              </Hidden>
            </Box>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
